export default 'UA-0000000-00'; // Criar um novo para Catálogo CARDS



/** WEBPACK FOOTER **
 ** ./src/api/googleAnalytics.js
 **/